import React from 'react';
import { OnboardingStep } from '../types';

interface StepIndicatorProps {
  steps: OnboardingStep[];
  currentStep: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-between">
      {steps.map((step, index) => {
        const StepIcon = step.icon;
        return (
          <div
            key={index}
            className={`flex items-center space-x-2 ${
              index <= currentStep ? 'text-white' : 'text-gray-500'
            }`}
          >
            <div className={`p-2 rounded-lg ${
              index <= currentStep ? 'bg-blue-500/10' : 'bg-gray-800/30'
            }`}>
              <StepIcon className={`h-5 w-5 ${
                index <= currentStep ? 'text-blue-500' : 'text-gray-500'
              }`} />
            </div>
            <div className="hidden sm:block">
              <div className="text-sm font-medium">{step.title}</div>
              <div className="text-xs text-gray-500">{step.description}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};